import 'external-svg-loader';

window.addEventListener('iconload', (event) => {
	event.target.classList.add('inline-svg--loaded');
});
